export const options = [
    {
        label: 'Sr Team',
        value: '1'
    },
    {
        label: 'Jr Team',
        value: '2'
    },
    {
        label: 'All Members',
        value: '0'
    },
]